import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { activePlan, subscriptionInitiate } from "service/apiUrl";
import { API } from "service/Interceptor";

const initialState = {
  hasError: false,
  isLoading: false,
  activePlan: {},
  subscribed: {},
  paymentOrderId: null,
};

export const initiateSubscription = createAsyncThunk(
  "startSubscription",
  async (payload, thunkAPI) => {
    try {
      const res = await API.post(subscriptionInitiate, payload);
      if (res?.data?.success) {
        return res?.data?.data;
      } else {
        return thunkAPI.rejectWithValue(
          res?.data?.message || "Error in getting orderId"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong in getting orderId"
      );
    }
  }
);

export const getActivePlanOfUser = createAsyncThunk(
  "getActivePlan",
  async (_, thunkAPI) => {
    try {
      const res = await API.get(activePlan);
      if (res?.data?.success) {
        return res?.data?.data ?? {};
      } else {
        console.log(res?.data?.message || "Error in getting active plans");
        return thunkAPI.rejectWithValue(
          res?.data?.message || "Error in getting active plans"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        "Something went wrong in getting active plans"
      );
    }
  }
);

const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActivePlanOfUser.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(getActivePlanOfUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        state.activePlan = action?.payload;
      })
      .addCase(getActivePlanOfUser.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
      })
      //------------------  Initiate Subscription API -------------------
      .addCase(initiateSubscription.pending, (state, action) => {
        state.isLoading = true;
        state.hasError = false;
      })
      .addCase(initiateSubscription.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasError = false;
        // state.activePlan.freeTrial = action.payload.isFreeTrial;
        state.subscribed = action?.payload;
        state.paymentOrderId = action?.payload?.paymentOrderId;
      })
      .addCase(initiateSubscription.rejected, (state) => {
        state.isLoading = false;
        state.hasError = true;
      });
  },
});

export default paymentSlice.reducer;
